import { useState } from 'react';
import RegistrationConfirmation from "./RegistrationConfirmation";
import RegistrationForm from "./RegistrationForm";
import { jsx as _jsx } from "react/jsx-runtime";
const RegistrationPage = () => {
  const [registeredUser, setRegisteredUser] = useState(null);
  return registeredUser ? /*#__PURE__*/_jsx(RegistrationConfirmation, {
    email: registeredUser.email
  }) : /*#__PURE__*/_jsx(RegistrationForm, {
    onCreateUser: setRegisteredUser
  });
};
export default RegistrationPage;